// extracted by mini-css-extract-plugin
export default {"container":"dP-z","title":"eP-z","link":"fP-z"};